import {
    GET_ORGANISATEURS,
    API_RESPONSE_SUCCESS,
    API_RESPONSE_ERROR,
  
    UPDATE_ORGANISATEUR,
    UPDATE_ORGANISATEUR_SUCCESS,
    UPDATE_ORGANISATEUR_FAIL,
    
    ADD_NEW_ORGANISATEUR,
    ADD_ORGANISATEUR_SUCCESS,
    ADD_ORGANISATEUR_FAIL,

  } from "./actionType";

  // common success
  export const organisateurApiResponseSuccess = (actionType, data) => ({
    type: API_RESPONSE_SUCCESS,
    payload: { actionType, data },
  });
  // common error
  export const organisateurApiResponseError = (actionType, error) => ({
    type: API_RESPONSE_ERROR,
    payload: { actionType, error },
  });
  
  export const getOrganisateurs = () => ({
    type: GET_ORGANISATEURS,
  });

  export const updateOrganisateur = organisateur => ({
    type: UPDATE_ORGANISATEUR,
    payload: organisateur,
  });
  
  export const updateOrganisateurSuccess = organisateur => ({
    type: UPDATE_ORGANISATEUR_SUCCESS,
    payload: organisateur,
  });
  
  export const updateOrganisateurFail = error => ({
    type: UPDATE_ORGANISATEUR_FAIL,
    payload: error,
  });
  
  export const addNewOrganisateur = organisateur => ({
    type: ADD_NEW_ORGANISATEUR,
    payload: organisateur,
  });
  
  export const addOrganisateurSuccess = organisateur => ({
    type: ADD_ORGANISATEUR_SUCCESS,
    payload: organisateur,
  });
  
  export const addOrganisateurFail = error => ({
    type: ADD_ORGANISATEUR_FAIL,
    payload: error,
  });